function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.5 97C75.2858 97 97 75.2858 97 48.5C97 21.7142 75.2858 0 48.5 0C21.7142 0 0 21.7142 0 48.5C0 75.2858 21.7142 97 48.5 97ZM46.402 21.1703L25.9638 35.2369C24.2274 36.4207 23.1784 38.3357 23.1784 40.39C23.1784 45.5779 29.2556 48.5723 33.6326 45.5779L48.5001 35.3761L63.3675 45.5779C67.7445 48.6071 73.8217 45.5779 73.8217 40.39C73.8217 38.3357 72.7727 36.3859 71.0363 35.2021L50.5981 21.1355C49.3321 20.2998 47.6681 20.2998 46.402 21.1703ZM46.402 45.5431L25.9638 59.5748C24.2274 60.7935 23.1784 62.7085 23.1784 64.7627C23.1784 69.9507 29.2556 72.9798 33.6326 69.9507L48.5001 59.7489L63.3675 69.9507C67.7445 72.9798 73.8217 69.9507 73.8217 64.7627C73.8217 62.7085 72.7727 60.7586 71.0363 59.5748L50.5981 45.5082C49.3321 44.6726 47.6681 44.6726 46.402 45.5431Z",
  fill: "#00BEA2"
});

var SvgChevronUpUpInCircleFill = function SvgChevronUpUpInCircleFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChevronUpUpInCircleFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-up-up-in-circle-fill.a25def50.svg";
export { ForwardRef as ReactComponent };